var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoInfluencer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E63FD689-3AC1-4253-8576-E1E7440314D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Influencer",
    transform: "translate(-1111.000000, -1324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 1194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(678.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_person",
    transform: "translate(4.000000, 6.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9701425,15.2425356 L0.0298574999,14.7574644 C0.0669673729,14.6090249 0.136376696,14.3660923 0.238816702,14.0587722 C0.409008561,13.5481967 0.613572074,13.0367879 0.855572809,12.5527864 C1.63427664,10.9953787 2.62965538,10 4,10 L12,10 C13.3703446,10 14.3657234,10.9953787 15.1444272,12.5527864 C15.3864279,13.0367879 15.5909914,13.5481967 15.7611833,14.0587722 C15.8636233,14.3660923 15.9330326,14.6090249 15.9701425,14.7574644 L14.0298575,15.2425356 C14.0044674,15.1409751 13.9488767,14.9464077 13.8638167,14.6912278 C13.7215086,14.2643033 13.5510721,13.8382121 13.3555728,13.4472136 C12.8842766,12.5046213 12.3796554,12 12,12 L4,12 C3.62034462,12 3.11572336,12.5046213 2.64442719,13.4472136 C2.44892793,13.8382121 2.27849144,14.2643033 2.1361833,14.6912278 C2.0511233,14.9464077 1.99553263,15.1409751 1.9701425,15.2425356 Z M12.5,4.5 C12.5,7.03594416 10.4880998,9 7.9594,9 C5.43979192,9 3.5,7.04432802 3.5,4.5 C3.5,1.93027192 5.38325049,0 7.9594,0 C10.5443925,0 12.5,1.93985587 12.5,4.5 Z M10.5,4.5 C10.5,3.04806224 9.4434275,2 7.9594,2 C6.49900951,2 5.5,3.023953 5.5,4.5 C5.5,5.94339227 6.54802808,7 7.9594,7 C9.39416024,7 10.5,5.92045789 10.5,4.5 Z",
    id: "shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7592402,15.5381091 C18.6191163,14.2598123 19.120916,12.7205905 19.120916,11.0641671 C19.120916,6.63164298 15.5276452,3.03837219 11.0951211,3.03837219 C7.90599322,3.03837219 5.15131028,4.89845205 3.85679304,7.592891",
    id: "Oval",
    stroke: "#FF5000",
    strokeWidth: 2,
    transform: "translate(11.488855, 9.288241) rotate(-30.000000) translate(-11.488855, -9.288241) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shape",
    stroke: "#FFFFFF",
    fill: "#FF5000",
    fillRule: "nonzero",
    points: "16.5372449 15.5338402 18.350781 11 20.1643171 15.5338402 25.701562 15.5338402 21.198751 19.136089 23.1138343 23.9237972 18.350781 21.0659652 13.5877277 23.9237972 15.502811 19.136089 11 15.5338402"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfluencer);
export default __webpack_public_path__ + "static/media/ico_influencer.3fdd189e5658cc42b1b3a768d3db4856.svg";
export { ForwardRef as ReactComponent };